import React, { useState } from 'react';

const NotFoundPage = () => {
  const [timeOut, setTimeOut] = useState(null)
  setTimeout(() => {
    setTimeOut(1)
  }, 30000);
  return (
    <div className="mt-5">
      {timeOut !== 1 ? (
        <div className="d-flex justify-content-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <div className="row">
          <div className="col-lg-2"></div>
          <div className="col-sm-12 col-lg-8">
            {" "}
           
              <div style={{ width: "100%" }} class="p-3 border border-2 ">
                <div class="shadow p-5  bg-body rounded">
                  <h1 style={{ color: "gray" }}>
                    500 <span class="text-danger">Server Error</span>
                  </h1>
                  <p>Oops,something went wrong.</p>
                  try to refresh this page or feel free to contact us if the
                  problem persists
                </div>
              </div>
          
          </div>
          <div className="col-lg-2"></div>
        </div>
      )}
    </div>
  );
};

export default NotFoundPage;